import React, { useEffect, useState } from 'react';

const MyStatusBar = () => {

    return (
        // <footer className='bg-secondary'>
        //     <div className='container py-4 py-md-5 px-4 px-md-3 text-white'>
        //         <ul className='m-0'>
        //             <li>خدمات پشتیبانی از زمان خرید سرویس، به مدت 6 ماه رایگان است.</li>
        //             <li>خدمات پشتیبانی شامل موارد زیر است:
        //                 <ul>
        //                     <li>ذخیره سازی و نگهداری اطلاعات و تصاویر خودرو مشتریان</li>
        //                     <li>خدمات ارسال پیامک</li>
        //                     <li>بهینه سازی و ارتقا سرویس</li>
        //                     <li>پاسخگویی به سوالات از طریق سامانه های متنی</li>
        //                 </ul>
        //             </li>
        //         </ul>
        //     </div>
        // </footer>
        <div></div>
    );
};

export default MyStatusBar;
